<template>
  <div class="flash-message">
    <div class="flash-message__text flash-message__text--error">{{ notification.text }}</div>
  </div>
</template>

<script>
export default {
  name: "ErrorNotification",
  props: {
    notification: {
      type: Object,
      default: null
    }
  }
};
</script>
